import { SyncOutlined } from '@ant-design/icons';

import { SidebarBanner } from '@app/shared/components/SidebarBanner';

import type { FC } from 'react';

interface FrontendUpdateNotificationProps {
  onClick: () => void;
  isSmall?: boolean;
}

export const FrontendUpdateNotification: FC<
  FrontendUpdateNotificationProps
> = ({ onClick, isSmall }) => (
  <SidebarBanner
    variant="warning"
    icon={<SyncOutlined />}
    title="Доступно обновление"
    subtitle="Нажмите, чтобы обновить"
    isSmall={isSmall}
    dataTestId="frontend-update-notification"
    onClick={onClick}
  />
);
